module.exports = __webpack_public_path__ + "static/media/convite.3d29e8c6.jpg";